import script from "./Projetos.vue?vue&type=script&setup=true&lang=js"
export * from "./Projetos.vue?vue&type=script&setup=true&lang=js"

import "./Projetos.vue?vue&type=style&index=0&id=9aef122c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9aef122c"]])

export default __exports__